import { useTranslation } from 'react-i18next'
import { motion } from 'framer-motion'

const Privacy = () => {
  const { t } = useTranslation()

  return (
    <div className="bg-dark-950 min-h-screen py-12 relative overflow-hidden">
      <div className="fixed inset-0 bg-grid-pattern opacity-20"></div>
      <div className="absolute inset-0 bg-gradient-mesh opacity-30"></div>

      <div className="container-custom relative z-10">
        <div className="max-w-3xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center mb-10"
          >
            <h1 className="text-4xl md:text-5xl font-black mb-4">
              <span className="text-gradient">{t('privacy.title')}</span>
            </h1>
            <div className="w-24 h-0.5 bg-gradient-to-r from-transparent via-primary-500 to-transparent mx-auto"></div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.6 }}
            className="card-hover"
          >
            <p className="text-base text-gray-300 leading-relaxed">
              {t('privacy.content')}
            </p>
          </motion.div>
        </div>
      </div>
    </div>
  )
}

export default Privacy
